import {
  TEMPLATE_ADD_JOURNEYSTATES,
  TEMPLATE_DELETE_JOURNEYSTATES,
  TEMPLATE_EDITOR_INIT_JOURNEY,
  TEMPLATE_SELECT_JOURNEYNODES,
  TEMPLATE_UPDATE_JOURNEYEDGES,
  TEMPLATE_UPDATE_JOURNEYNODEPROPERTY,
  TEMPLATE_UPDATE_JOURNEYNODES
} from '../../actions';
import {
  addJourneyStates,
  deleteJourneyStates,
  getIntialFormJourneyState,
  updateJourneyEdges,
  updateJourneyNodeProperty,
  updateJourneyNodes,
  updateSelectedJourneyNodes
} from './updaters';

export default function formJourneyReducer(draftState, action) {
  const { payload } = action;

  switch (action.type) {
    case TEMPLATE_EDITOR_INIT_JOURNEY:
      return getIntialFormJourneyState(draftState);

    case TEMPLATE_SELECT_JOURNEYNODES:
      return updateSelectedJourneyNodes(draftState, payload);

    case TEMPLATE_UPDATE_JOURNEYNODES:
      return updateJourneyNodes(draftState, payload);

    case TEMPLATE_UPDATE_JOURNEYEDGES:
      return updateJourneyEdges(draftState, payload);

    case TEMPLATE_UPDATE_JOURNEYNODEPROPERTY:
      return updateJourneyNodeProperty(draftState, payload);

    case TEMPLATE_ADD_JOURNEYSTATES:
      return addJourneyStates(draftState, payload);

    case TEMPLATE_DELETE_JOURNEYSTATES:
      return deleteJourneyStates(draftState, payload);

    default:
      return draftState;
  }
}
